import { useState, useMemo, useCallback } from "react";
import "./WordCloud.css";

const CATEGORIES = ["library", "framework", "language", "software"];

function WordCloud({ list, size }) {
  const [organize, setOrganize] = useState(true);

  const generateRandomHSL = useCallback(() => {
    return `hsla(${~~(360 * Math.random())}, 90%, 40%, 1)`;
  }, []);

  const colorDict = useMemo(() => {
    const dict = {};
    list.forEach((item) => {
      if (!dict[item[2]]) {
        dict[item[2]] = generateRandomHSL();
      }
    });
    return dict;
  }, [list, generateRandomHSL]);

  const processedList = useMemo(() => {
    return list.map((item) => [
      item[0],
      item[1] * item[1] * size,
      colorDict[item[2]],
      item[1],
    ]);
  }, [list, size, colorDict]);

  const sortedByType = useMemo(() => {
    const sortByType = {};
    list.forEach((item) => {
      if (!sortByType[item[2]]) {
        sortByType[item[2]] = [];
      }
      sortByType[item[2]].push(item[0]);
    });
    return sortByType;
  }, [list]);

  const toggleOrganize = useCallback(() => {
    setOrganize((prev) => !prev);
  }, []);

  return (
    <div className="wordcloud-container">
      <h2 className="heading">TECH STACK</h2>
      <h1 className="wc-btn" onClick={toggleOrganize}>
        Click Me
      </h1>

      {organize ? (
        <div className="wordcloud-div">
          <div className="wordcloud-key">
            <section className="span-container">
              {CATEGORIES.map((category) => (
                <span
                  key={category}
                  className="cat-label"
                  style={{ color: colorDict[category] }}
                >
                  {category.toUpperCase()}
                </span>
              ))}
            </section>
          </div>
          <ul className="wordcloud">
            {processedList.map((item) => (
              <li
                key={item[0]}
                className="tooltip"
                style={{ fontSize: item[1], color: item[2] }}
              >
                {item[0]}
                <span className="tooltiptext">Confidence: {item[3]}/10</span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="org-wc">
          <section className="span-container"></section>
          <div className="list-container">
            {CATEGORIES.map((category) => (
              <div key={category} className="org-div">
                <span
                  className="cat-label"
                  style={{ color: colorDict[category] }}
                >
                  {category.toUpperCase()}
                </span>
                <ul>
                  {sortedByType[category]?.map((item) => (
                    <li
                      key={item}
                      className="organize-item"
                      style={{ color: colorDict[category] }}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default WordCloud;
